import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Linkedin, Twitter, Github, MapPin } from 'lucide-react';
import { serviceAreas } from '../data/locationData';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-theme-dark text-white">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="md:col-span-1">
            <div className="flex items-center space-x-3 mb-4">
              <div className="relative w-16 h-16">
                <img src="/trika-logo.png" alt="Trika Studio Logo" className="w-full h-full object-contain" />
              </div>
              <span className="text-xl font-bold font-['Space_Grotesk']">
                Trika Studio
              </span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              You found us. We'll help customers find your business.
            </p>
          </div>

          {/* Services Column */}
          <div>
            <h3 className="font-['Space_Grotesk'] font-bold text-white mb-4">Services</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/services" className="text-gray-400 hover:text-theme-accent transition-colors text-sm">
                  Web Development
                </Link>
              </li>
              <li>
                <Link to="/seo" className="text-gray-400 hover:text-theme-accent transition-colors text-sm">
                  SEO
                </Link>
              </li>
              <li>
                <Link to="/google-ads" className="text-gray-400 hover:text-theme-accent transition-colors text-sm">
                  Google Ads (PPC)
                </Link>
              </li>
              <li>
                <Link to="/social-media-marketing" className="text-gray-400 hover:text-theme-accent transition-colors text-sm">
                  Social Media Marketing
                </Link>
              </li>
              <li>
                <Link to="/content-marketing" className="text-gray-400 hover:text-theme-accent transition-colors text-sm">
                  Content Marketing
                </Link>
              </li>
              <li>
                <Link to="/digital-marketing" className="text-gray-400 hover:text-theme-accent transition-colors text-sm">
                  All Marketing Services
                </Link>
              </li>
            </ul>
          </div>

          {/* Company & Industries Column */}
          <div>
            <h3 className="font-['Space_Grotesk'] font-bold text-white mb-4">Company</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-gray-400 hover:text-theme-accent transition-colors text-sm">
                  About
                </Link>
              </li>
              <li>
                <Link to="/work" className="text-gray-400 hover:text-theme-accent transition-colors text-sm">
                  Work
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-gray-400 hover:text-theme-accent transition-colors text-sm">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-gray-400 hover:text-theme-accent transition-colors text-sm">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-theme-accent transition-colors text-sm">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/review-request" className="text-gray-400 hover:text-theme-accent transition-colors text-sm">
                  Leave a Review
                </Link>
              </li>
            </ul>
            <h3 className="font-['Space_Grotesk'] font-bold text-white mb-4 mt-6">Industries</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/home-services" className="text-gray-400 hover:text-theme-accent transition-colors text-sm">
                  Home Services (Hub)
                </Link>
              </li>
              <li>
                <Link to="/law-firm-marketing" className="text-gray-400 hover:text-theme-accent transition-colors text-sm">
                  Law Firm Marketing
                </Link>
              </li>
              <li>
                <Link to="/medical-practice-marketing" className="text-gray-400 hover:text-theme-accent transition-colors text-sm">
                  Medical Practice Marketing
                </Link>
              </li>
              <li>
                <Link to="/construction-web-design" className="text-gray-400 hover:text-theme-accent transition-colors text-sm">
                  Construction Web Design
                </Link>
              </li>
              <li>
                <Link to="/dental-web-design" className="text-gray-400 hover:text-theme-accent transition-colors text-sm">
                  Dental Web Design
                </Link>
              </li>
              <li>
                <Link to="/roofing-web-design" className="text-gray-400 hover:text-theme-accent transition-colors text-sm">
                  Roofing Web Design
                </Link>
              </li>
              <li>
                <Link to="/plumber-web-design" className="text-gray-400 hover:text-theme-accent transition-colors text-sm">
                  Plumber Web Design
                </Link>
              </li>
              <li>
                <Link to="/hvac-web-design" className="text-gray-400 hover:text-theme-accent transition-colors text-sm">
                  HVAC Web Design
                </Link>
              </li>
              <li>
                <Link to="/electrician-web-design" className="text-gray-400 hover:text-theme-accent transition-colors text-sm">
                  Electrician Web Design
                </Link>
              </li>
              <li>
                <Link to="/landscaping-web-design" className="text-gray-400 hover:text-theme-accent transition-colors text-sm">
                  Landscaping Web Design
                </Link>
              </li>
              <li>
                <Link to="/restaurant-web-design" className="text-gray-400 hover:text-theme-accent transition-colors text-sm">
                  Restaurant Web Design
                </Link>
              </li>
              <li>
                <Link to="/real-estate-web-design" className="text-gray-400 hover:text-theme-accent transition-colors text-sm">
                  Real Estate Web Design
                </Link>
              </li>
              <li>
                <Link to="/nonprofit-web-design" className="text-gray-400 hover:text-theme-accent transition-colors text-sm">
                  Nonprofit Web Design
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h3 className="font-['Space_Grotesk'] font-bold text-white mb-4">Get in Touch</h3>
            <div className="space-y-3">
              <a 
                href="mailto:info@trikastudio.com" 
                className="flex items-center text-gray-400 hover:text-theme-accent transition-colors text-sm group"
              >
                <Mail className="w-4 h-4 mr-2 group-hover:scale-110 transition-transform" />
                info@trikastudio.com
              </a>
              <a 
                href="tel:+19192295525" 
                className="block text-gray-400 hover:text-theme-accent transition-colors text-sm"
              >
                (919) 229-5525
              </a>
            </div>

            {/* Social Icons */}
            <div className="flex items-center space-x-4 mt-6">
              <a 
                href="https://www.linkedin.com/company/trika-studio" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-theme-accent transition-colors"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a 
                href="https://x.com/trikastudio" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-theme-accent transition-colors"
              >
                <Twitter className="w-5 h-5" />
              </a>
              <a 
                href="https://github.com/trikastudio" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-theme-accent transition-colors"
              >
                <Github className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Areas We Serve */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-8">
          <div className="flex items-center gap-2 mb-4">
            <MapPin className="w-4 h-4 text-theme-accent" />
            <h3 className="font-['Space_Grotesk'] font-bold text-white text-sm">Areas We Serve</h3>
          </div>
          <div className="flex flex-wrap gap-x-5 gap-y-2">
            {serviceAreas.map((area) => (
              <Link
                key={area.name}
                to={area.slug ? `/${area.slug}` : `/contact`}
                className="text-gray-400 hover:text-theme-accent transition-colors text-xs"
              >
                {area.name}, NC
              </Link>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © {currentYear} Trika Studio. All rights reserved.
            </p>
            <div className="flex items-center space-x-6">
              <Link to="/privacy" className="text-gray-400 hover:text-theme-accent transition-colors text-sm">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-gray-400 hover:text-theme-accent transition-colors text-sm">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
